<template>
  <!-- <el-row class="login-layout">
    <div class="login-content">
      <div class="main">
        <div class="logo">
          <img src="@/assets/images/logo.png" alt />
        </div>
        <router-view></router-view>
      </div>
    </div>
    
    <div class="login-images">
      <div class="images-box">
        <i-image></i-image>
      </div>
    </div>
    <footer class="footer-div">
      <span>Copyright© <a href="https://beian.miit.gov.cn/">琼ICP备2022002438号-5</a></span>
    </footer>
  </el-row> -->
  <div class="login-page">
    <div class="login-content">
      <div class="main">
        <div class="logo">
          <!-- <img src="@/assets/images/logo.png" alt /> -->
        </div>
        <router-view></router-view>
      </div>
    </div>

    <!-- <div class="login-images">
			<div class="images-box">
				<i-image></i-image>
			</div>
		</div> -->
    <footer class="footer-div">
      <!-- <span
        >Copyright©
        <a href="https://beian.miit.gov.cn/">琼ICP备2023000558号-12</a>
        网站版权所有：海口美兰奥业峰网络科技工作室
      </span> -->
    </footer>
  </div>
</template>
<script>
import iImage from "./module/images.vue";
export default {
  components: {
    iImage,
  },
  mounted() {},
  methods: {},
};
</script>

<style lang="scss" scoped>
// .login-layout,
// .login-content,
// .login-images,
// .images-box {
// 	height: 100vh;
// 	overflow: auto;
// }
.login-content {
  // position: relative;
  // float: left;
  // margin-right: -600px;
  // width: 500px;
  width: 40%;
  min-width: 500px;
  // height: 100%;
  display: flex;
  align-items: center;
  background-color: white;
  height: calc(100% - 49px);
  overflow: scroll;
  .main {
    margin: 0 auto;
    // display: flex;
    // flex-direction: column;
    // position: absolute;
    // top: 50%;
    // margin-top: -300px;
    // left: 50%;
    // margin-left: -200px;
    // height: 600px;
    // height: 100%;
    width: 400px;
    // min-height: 100%;
    .logo {
      width: 225px;
      img {
        width: 100%;
      }
    }
  }
}

.footer-div {
  margin: 0 auto;
  // position: fixed;
  // z-index: 999;
  // left: 0;
  // bottom: 0;
  height: 49px;
  text-align: center;
  width: 100%;
  font-size: 12px;
  color: hsla(0, 0%, 100%, 0.6);
  line-height: 49px;
  background: #181f31;
}

.login-images {
  float: right;
  width: 100%;
  .images-box {
    margin-left: 550px;
  }
}

.login-page {
  width: 100%;
  height: 100%;
  background: url("~@/assets/images/login/banner1.jpg");
  background-repeat: no-repeat;
  background-size: cover;
}
</style>
